module.exports = __webpack_public_path__ + "img/lotto-list-item-bg-light-special-active.e1f3582c.png";